import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntExpanderComponent } from './int-expander.component';


@NgModule({
  declarations: [
    IntExpanderComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IntExpanderComponent
  ]
})
export class IntExpanderModule { }
